module.exports = __webpack_public_path__ + "img/footer-bg-img.bcee8eea.svg";